module.exports = __webpack_public_path__ + "img/dzpdf5.da9bd2a1.png";